import React from "react";
import { useTheme } from "next-themes";
import PricingCards from "./PricingCards";
import { Button } from "./ui/button";
import { openWhatsApp } from "../lib/whatsapp";
import Iridescence from "./Iridescence";
import { IRIDESCENCE_DARK, IRIDESCENCE_LIGHT } from "../lib/iridescence";

const PlansSection = () => {
  const MemoIridescence = React.memo(Iridescence);
  const { theme } = useTheme();

  return (
    <section id="planes" className="pt-20 pb-0 bg-background text-foreground">
      <PricingCards />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative mt-16 overflow-hidden rounded-2xl shadow-lg text-center">
          <div className="absolute inset-0 bg-gradient-to-br from-[#f9fbff] via-white to-[#eef7ff] dark:from-[#07070b] dark:via-[#120b14] dark:to-[#2a0f0f]" />
          <div
            className="absolute inset-0 opacity-04 pointer-events-none dark:hidden"
            key={`light-${theme}`}
            style={{ transform: "scale(1.6)" }}
          >
            <MemoIridescence color={IRIDESCENCE_LIGHT} speed={0.08} amplitude={0.01} />
          </div>
          <div
            className="absolute inset-0 opacity-03 pointer-events-none hidden dark:block"
            key={`dark-${theme}`}
            style={{ transform: "scale(1.6)" }}
          >
            <MemoIridescence color={IRIDESCENCE_DARK} speed={0.08} amplitude={0.01} />
          </div>
          <div className="relative z-10 p-8 text-white">
            <h3 className="text-2xl font-bold text-white mb-4 drop-shadow-[0_2px_12px_rgba(0,0,0,0.45)]">
              ¿No encontraste la combinación perfecta?
            </h3>
            <p className="text-white/85 mb-6 max-w-xl mx-auto drop-shadow-[0_1px_8px_rgba(0,0,0,0.4)]">
              Armamos un pack a tu medida con los servicios que necesites para cubrir todas tus necesidades.
            </p>
            <Button
              variant="outline"
              className="border-white/60 text-white bg-transparent hover:bg-transparent hover:text-white"
              onClick={() => openWhatsApp("Hola, me gustaría consultar por un pack personalizado.")}
            >
              Consultar Ahora
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PlansSection;
